
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M12.88 5.05001C16.06 5.45001 18.55 7.94001 18.95 11.12C19.01 11.63 19.44 12 19.94 12C19.98 12 20.02 12 20.06 11.99C20.61 11.92 21 11.42 20.93 10.87C20.42 6.78001 17.21 3.57001 13.12 3.06001C12.57 3.00001 12.07 3.39001 12.01 3.94001C11.94 4.49001 12.33 4.99001 12.88 5.05001ZM13.26 7.16001C12.73 7.02001 12.18 7.34001 12.04 7.88001C11.9 8.42001 12.22 8.96001 12.76 9.10001C13.81 9.37001 14.63 10.19 14.91 11.25C15.03 11.7 15.43 12 15.88 12C15.96 12 16.05 11.99 16.13 11.97C16.66 11.83 16.98 11.28 16.85 10.75C16.38 8.98001 15.01 7.61001 13.26 7.16001ZM19.23 15.26L16.69 14.97C16.08 14.9 15.48 15.11 15.05 15.54L13.21 17.38C10.38 15.94 8.06004 13.63 6.62004 10.79L8.47004 8.94001C8.90004 8.51001 9.11004 7.91001 9.04004 7.30001L8.75004 4.78001C8.63004 3.77001 7.78004 3.01001 6.76004 3.01001H5.03004C3.90004 3.01001 2.96004 3.95001 3.03004 5.08001C3.56004 13.62 10.39 20.44 18.92 20.97C20.05 21.04 20.99 20.1 20.99 18.97V17.24C21 16.23 20.24 15.38 19.23 15.26Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-phone-in-talk`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconPhoneInTalk

    ```js
    <b-new-b-icon-phone-in-talk />
    ```
</docs>


